<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>学生管理</Breadcrumb-item>
        <Breadcrumb-item>学员风险</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="100" :show-message="false" label-position="right">
        <Row :gutter="32">
          <Col :span="6">
            <Form-item label="等级">
              <Select v-model="queryParam.level" clearable placeholder="全部">
                <Option :value="0">低</Option>
                <Option :value="1">中</Option>
                <Option :value="2">高</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="学导">
              <admin-user-select :status="1" adminGroupCode="userStudyAdviser"
                                 v-model="queryParam.studyAdviserId"></admin-user-select>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="天数">
              <InputNumber v-model="queryParam.days" :min="1" :max="90" style="width: 100%;"></InputNumber>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="仅未跟进">
              <i-switch v-model="queryParam.unfollowedOnly"></i-switch>
            </Form-item>
          </Col>
          <Col :span="6">
            <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search" @click="search">搜索</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <List
      v-if="aiAllowed"
      ref="dataList"
      :tableColumns="title"
      :reload="reload"
      listUrl="/studentRisk/list"
      :params="queryParam"
      :onLoading="onLoading"
    />
    <AiDrawer
      :visible.sync="aiVisible"
      :uid="aiUid"
      :snapshot-id="aiSnapshotId"
      page-route="/user/studentRiskList"
      default-task-type="RISK_EXPLAIN"
      @on-executed="onAiExecuted"
      @on-close="onAiClose"
    />
    <Modal title="写跟进" v-model="showFollowupModal" :mask-closable="false">
      <Form :label-width="90">
        <Form-item label="动作" required>
          <Select v-model="followupForm.action" placeholder="请选择">
            <Option value="CALL">CALL 电话</Option>
            <Option value="REMARK">REMARK 备注</Option>
            <Option value="TRANSFER">TRANSFER 转交</Option>
            <Option value="IGNORE">IGNORE 忽略</Option>
          </Select>
        </Form-item>
        <Form-item label="结果">
          <Select v-model="followupForm.result" clearable placeholder="可空">
            <Option value="MISREPORT">MISREPORT</Option>
            <Option value="SCHEDULE">SCHEDULE</Option>
            <Option value="LEARNING">LEARNING</Option>
            <Option value="SERVICE">SERVICE</Option>
            <Option value="PRICE">PRICE</Option>
            <Option value="PAUSE">PAUSE</Option>
            <Option value="RECOVERED">RECOVERED</Option>
            <Option value="LOST">LOST</Option>
          </Select>
        </Form-item>
        <Form-item label="说明">
          <Input type="textarea" :rows="3" v-model="followupForm.comment" placeholder="跟进说明"></Input>
        </Form-item>
        <Form-item label="写跟踪">
          <Checkbox v-model="followupForm.writeTrack">同时写 user_track_record（trackType=61，不推送）</Checkbox>
        </Form-item>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="showFollowupModal = false">取消</Button>
        <Button type="primary" size="large" :loading="followupLoading" @click="submitFollowup">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import AiDrawer from '@/components/ai/AiDrawer'
import { RISK_URI } from '@/tools/aiApi'
import { fetchAiAllowed } from '@/tools/aiAccess'

export default {
  name: 'StudentRiskList',
  components: {
    AiDrawer
  },
  data: function () {
    return {
      searchLoading: false,
      reload: 0,
      aiVisible: false,
      aiUid: null,
      aiAllowed: false,
      aiSnapshotId: null,
      showFollowupModal: false,
      followupLoading: false,
      followupForm: {
        snapshotId: null,
        uid: null,
        action: 'CALL',
        result: null,
        comment: '',
        writeTrack: false
      },
      queryParam: {
        level: null,
        studyAdviserId: null,
        days: 7,
        unfollowedOnly: true
      },
      title: [
        {
          title: '学生ID',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            let uid = row.uid
            return h('a', {on: {click: () => this.openStudent(uid)}}, uid)
          }
        },
        {
          title: '等级',
          width: 80,
          align: 'center',
          render: (h, params) => {
            let level = params.row.level
            let text = this.levelText(level)
            let color = Number(level) === 2 ? '#ed4014' : (Number(level) === 1 ? '#ff9900' : '#19be6b')
            return h('span', {style: {color: color, fontWeight: '600'}}, text)
          }
        },
        {
          title: '分数',
          width: 80,
          align: 'center',
          key: 'score'
        },
        {
          title: '原因摘要',
          align: 'center',
          render: (h, params) => {
            let text = this.reasonText(params.row)
            if (!text) {
              return h('span', '')
            }
            return h('Poptip', {
              props: {
                trigger: 'hover',
                placement: 'top',
                transfer: true
              }
            }, [
              h('span', {
                style: {
                  display: 'inline-block',
                  maxWidth: '220px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  verticalAlign: 'middle'
                }
              }, text),
              h('div', {
                slot: 'content',
                style: {
                  maxWidth: '360px',
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                  textAlign: 'left'
                }
              }, text)
            ])
          }
        },
        {
          title: '学导',
          width: 120,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('span', row.studyAdviserName || row.studyAdviserId || '')
          }
        },
        {
          title: '计算日',
          width: 120,
          align: 'center',
          render: (h, params) => {
            return h('span', params.row.calcDate || params.row.calc_date || '')
          }
        },
        {
          title: '是否已跟进',
          width: 110,
          align: 'center',
          render: (h, params) => {
            return h('span', this.followedText(params.row))
          }
        },
        {
          title: '操作',
          width: 140,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            let row = params.row
            return h('span', [
              h('a', {on: {click: () => this.openExplain(row)}}, '解释'),
              h('span', '  '),
              h('a', {on: {click: () => this.openFollowup(row)}}, '写跟进')
            ])
          }
        }
      ]
    }
  },
  created: function () {
    var self = this
    fetchAiAllowed(this.$http).then(function (allowed) {
      if (!allowed) {
        self.$router.replace('/index')
        return
      }
      self.aiAllowed = true
    })
  },
  methods: {
    search: function () {
      this.reload = new Date().getTime()
    },
    onLoading: function (loading) {
      this.searchLoading = loading
    },
    levelText: function (level) {
      if (Number(level) === 2) {
        return '高'
      }
      if (Number(level) === 1) {
        return '中'
      }
      if (Number(level) === 0) {
        return '低'
      }
      return level == null ? '' : String(level)
    },
    reasonText: function (row) {
      let raw = row.reasonsJson || row.reasons_json || row.reasonSummary || row.reasonText || row.reasons || ''
      if (raw && typeof raw === 'object') {
        try {
          return JSON.stringify(raw)
        } catch (e) {
          return String(raw)
        }
      }
      return raw || ''
    },
    followedText: function (row) {
      if (row.followed === true || row.hasFollowup === true || row.followedFlag === true || row.unfollowed === false) {
        return '已跟进'
      }
      if (row.lastFollowupTime || row.followupTime || row.lastFollowTime || row.followupId) {
        return '已跟进'
      }
      if (row.followed === false || row.hasFollowup === false || row.unfollowed === true) {
        return '未跟进'
      }
      return row.followedText || '未跟进'
    },
    openStudent: function (uid) {
      if (!uid) {
        return
      }
      let resolved = this.$router.resolve({
        name: 'userPayDetail',
        query: {uid: uid, tabName: 0, backPath: '/user/studentRiskList'}
      })
      window.open(resolved.href, '_blank')
    },
    openExplain: function (row) {
      this.aiUid = row.uid
      this.aiSnapshotId = row.snapshotId || row.id
      this.aiVisible = true
    },
    openFollowup: function (row) {
      this.followupForm = {
        snapshotId: row.snapshotId || row.id,
        uid: row.uid,
        action: 'CALL',
        result: null,
        comment: '',
        writeTrack: false
      }
      this.showFollowupModal = true
    },
    submitFollowup: function () {
      let self = this
      if (!self.followupForm.snapshotId) {
        self.$Message.warning('缺少快照')
        return
      }
      if (!self.followupForm.action) {
        self.$Message.warning('请选择动作')
        return
      }
      self.followupLoading = true
      self.$http.post(RISK_URI.followup, {
        snapshotId: self.followupForm.snapshotId,
        action: self.followupForm.action,
        result: self.followupForm.result,
        comment: self.followupForm.comment,
        writeTrack: self.followupForm.writeTrack
      }).then(function (res) {
        self.followupLoading = false
        if (res && res.status === 'ok') {
          self.showFollowupModal = false
          self.reload = new Date().getTime()
          self.$Message.success('跟进已保存')
        }
      }).catch(function () {
        self.followupLoading = false
      })
    },
    onAiClose: function () {
      this.aiVisible = false
      this.aiUid = null
      this.aiSnapshotId = null
    },
    onAiExecuted: function () {
      this.reload = new Date().getTime()
    }
  }
}
</script>



// WEBPACK FOOTER //
// StudentRiskList.vue?f5045ed2